/**
 * In-memory cache for GET /GetRegionalBranchZipcodeAnalytics responses.
 * Key: normalized managing_branch_name (lowercase, trimmed).
 */

const cache = new Map();

export function regionalBranchZipcodeAnalyticsCacheKey(branch) {
  return String(branch ?? '')
    .trim()
    .toLowerCase()
    .slice(0, 50);
}

/**
 * @returns {{ data: object, refreshedAt: number } | null}
 */
export function getRegionalBranchZipcodeAnalyticsCache(branch) {
  const key = regionalBranchZipcodeAnalyticsCacheKey(branch);
  if (!key) return null;
  return cache.get(key) ?? null;
}

export function setRegionalBranchZipcodeAnalyticsCache(branch, entry) {
  const key = regionalBranchZipcodeAnalyticsCacheKey(branch);
  if (!key || !entry?.data) return;
  cache.set(key, {
    data: entry.data,
    refreshedAt: entry.refreshedAt ?? Date.now(),
  });
}

export function invalidateRegionalBranchZipcodeAnalyticsCache(branch) {
  const key = regionalBranchZipcodeAnalyticsCacheKey(branch);
  if (key) cache.delete(key);
}

/** Build zip -> analytics row lookup for map popups and filters. */
export function buildZipcodeStatsMap(analyticsData) {
  const map = {};
  const list = analyticsData?.zipcodes;
  if (!Array.isArray(list)) return map;
  for (const row of list) {
    const zip = String(row?.zipcode ?? '').trim();
    if (zip) map[zip] = row;
  }
  return map;
}
